import React from "react";

const Footer: React.FC = () => (
    <footer className="footer">
        <p>© {new Date().getFullYear()} Cedarwood Wellness. All rights reserved.</p>
        <p style={{ fontSize: '14px', margin: 8 }}>Designed by: pradnesh.jogwar@gmail.com</p>
    </footer>
);

export default Footer;
